import { PropertyMetricCollectionJSON, StudentAercoMetric } from './';
import { EntityBase } from './EntityBase';
import { AercoMetric } from './Metrics';

export interface UnitTypeJSON {
  unitType: string;
  unitCount: number;
  totalSquareFootage: number;
}

export interface SHUnitTypeJSON {
  avgsqftperbed: number;
  bedroomtypedisplay: string;
}

export interface UnitTypeMetricJSON extends PropertyMetricCollectionJSON {
  unittype: string;
  totalunitcount: number;
  totalsquarefootage: number;
}

export interface SHUnitTypeMetricJSON extends PropertyMetricCollectionJSON {
  avgsqftperbed: number;
  bedroomtypedisplay: string;
}

export class UnitType extends EntityBase implements UnitTypeJSON {
  unitType: string;
  unitCount: number;
  totalSquareFootage: number;

  constructor(json: UnitTypeJSON) {
    super(json);
    if (!json) return this;

    this.unitType = UnitType.formatUnitType(json.unitType);
    this.unitCount = json.unitCount;
    this.totalSquareFootage = json.totalSquareFootage;
  }

  protected static formatUnitType(unitType: string): string {
    return unitType === 'E' ? 'Studio' : `${unitType} BR`;
  }

  public static sortByUnitType(left: UnitTypeJSON, right: UnitTypeJSON): number {
    if (!left) return 1;
    if (!right) return -1;

    if (left.unitType === 'E') return -1;
    if (right.unitType === 'E') return 1;

    return +left.unitType <= +right.unitType ? -1 : 1;
  }
}

export class SHUnitType extends EntityBase implements UnitTypeJSON {
  unitType: string;
  unitCount: number;
  totalSquareFootage: number;

  constructor(json: SHUnitTypeJSON) {
    super(json);
    if (!json) return this;
    this.unitType = SHUnitType.formatUnitType(json.bedroomtypedisplay);
    this.totalSquareFootage = json.avgsqftperbed;
  }

  protected static formatUnitType(unitType: string): string {
    return unitType === 'Studio' ? unitType : `${SHUnitType.getNumberFromWord(unitType)} BR`;
  }

  public static sortByUnitType(left: UnitTypeJSON, right: UnitTypeJSON): number {
    if (!left) return 1;
    if (!right) return -1;

    if (left.unitType === 'Studio') return -1;
    if (right.unitType === 'Studio') return 1;

    return +left.unitType <= +right.unitType ? -1 : 1;
  }

  public static getNumberFromWord(word: string): number {
    const wordsInNumber = {
      "ONE": 1,
      "TWO": 2,
      "THREE": 3,
      "FOUR": 4,
      "FIVE": 5
    }
    return wordsInNumber[word.toUpperCase()];
  }
}


export class UnitTypeMetric extends UnitType implements UnitTypeJSON {
  metrics: AercoMetric;

  constructor(details: UnitTypeJSON, metrics: UnitTypeMetricJSON) {
    super(details);
    this.metrics = metrics && metrics.metrics ? AercoMetric.fromJSON(metrics.metrics) : null;
  }
}

export class StudentUnitTypeMetric extends SHUnitType implements UnitTypeJSON {
  metrics: StudentAercoMetric;

  constructor(details: SHUnitTypeJSON, metrics: SHUnitTypeMetricJSON) {
    super(details);
    this.metrics = metrics && metrics.metrics ? StudentAercoMetric.fromJSON(metrics.metrics) : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/UnitType.ts